import { Modal, Typography } from 'antd';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const { Title, Paragraph, Text } = Typography;
const LastUpdate = ({ updateOpen, setUpdateOpen, updateClose, newCamera, isMobileOnly }) => {


    return <Modal
        open={updateOpen}
        centered
        title={<div>近期更新 {dayjs(newCamera[0]?.checktime)?.format('YYYY-MM-DD')}{updateClose > 0 && <span className="update-close">{updateClose}s</span>}</div>}
        footer={null}
        width={isMobileOnly ? "90%" : 600}
        onCancel={() => setUpdateOpen(false)}
    >
        <div></div>
        <Paragraph style={{ fontWeight: 400 }}>
            <ul style={{ maxHeight: 300, overflowY: 'auto' }}>
                {
                    newCamera.map((c, i) => {
                        return (
                            <li key={i}>{c.name}</li>
                        )
                    })
                }
            </ul>
        </Paragraph>
        <Title level={5}>小技巧</Title>
        <Paragraph style={{ fontWeight: 400 }}>
            （1）点击地图任意点，可设置 “起点”、“途经点”、“终点”，无提示也可输入<br />
            <Text strong style={{ color: 'red' }}>（若无反应，请尝试详细地址如：区＋街道＋门牌号！！！）</Text><br />
            （2）规划失败可尝试分段，如：出京先导航六环某某出入口或六环外某地点<br />
            <Text strong style={{ color: 'red' }}>（记得办理六环外进京证！！！）</Text><br />
            （3）规划成功后，可勾选显示全部摄像头，确认路线信息，以防万一<br />
            {/* （根据路况实时导航路线仍有极小概率与规划路线不一致，请仔细甄别） */}
            <Text strong style={{ color: 'red' }}>（任何问题可公众号留言！！！）</Text>
        </Paragraph>
        <Title level={5}>声明</Title>
        <Paragraph style={{ fontWeight: 400, marginBottom: 0, paddingBottom: 0 }}>
            本页信息来源于互联网，仅供学习测试使用，请自觉遵守相关法律法规
        </Paragraph>
    </Modal>
}
export default LastUpdate